import React from 'react'
import styles from './MicrositeDateRangePicker.module.css'
import { ArrowRight } from 'lucide-react'

/**
 * MicrositeDateRangePicker
 * From + To date pickers, used for analytics date ranges
 * (Page Views, Conversions) and scheduling (popups, announcements).
 *
 * Usage:
 *   <MicrositeDateRangePicker
 *     fromValue={fromDate}
 *     toValue={toDate}
 *     onFromChange={setFromDate}
 *     onToChange={setToDate}
 *   />
 */
const MicrositeDateRangePicker = ({
    label,
    fromValue,
    toValue,
    onFromChange,
    onToChange,
    fromLabel = 'From',
    toLabel = 'To'
}) => (
    <div className={styles.field}>
        {label && <label className={styles.label}>{label}</label>}
        <div className={styles.row}>
            <div className={styles.col}>
                <span className={styles.subLabel}>{fromLabel}</span>
                <input
                    type="date"
                    className={styles.input}
                    value={fromValue || ''}
                    onChange={(e) => onFromChange?.(e.target.value)}
                />
            </div>
            <ArrowRight size={13} className={styles.arrow} />
            <div className={styles.col}>
                <span className={styles.subLabel}>{toLabel}</span>
                <input
                    type="date"
                    className={styles.input}
                    value={toValue || ''}
                    onChange={(e) => onToChange?.(e.target.value)}
                />
            </div>
        </div>
    </div>
)

export default MicrositeDateRangePicker